import React from 'react';
import ImageDragDrop from '~/admin/components/questions/ImageDragDrop.jsx';

export default function ImageDragDropDemo() {
  const { buildImageDemo } = require('./demoData');
  const { items, targets, answers } = buildImageDemo();
  const handleChange = (report) => {
    // also log slotAnswers string
    if (report && Array.isArray(report.slotAnswers)) {
      console.log('Slot answers:', report.slotAnswers.join(', '));
    }
  };

  return (
    <div style={{ padding: 18 }}>
      <h3>Image Drag & Drop — Demo (using payload)</h3>
      <ImageDragDrop items={items} targets={targets} answers={answers} onChange={handleChange} showExpected />
    </div>
  );
}
